import { render, staticRenderFns } from "./auditRecord.vue?vue&type=template&id=bd34dc8c&scoped=true"
import script from "./auditRecord.vue?vue&type=script&lang=js"
export * from "./auditRecord.vue?vue&type=script&lang=js"
import style0 from "./auditRecord.vue?vue&type=style&index=0&id=bd34dc8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd34dc8c",
  null
  
)

export default component.exports